export const MALAYSIA_STATES = [
  "",
  "ジョホール州（Johor）",
  "ケダ州（Kedah）",
  "クランタン州（Kelantan）",
  "マラッカ州（Malacca / Melaka）",
  "ヌグリ・スンビラン州（Negeri Sembilan）",
  "パハン州（Pahang）",
  "ペナン州（Penang / Pulau Pinang）",
  "ペラ州（Perak）",
  "プルリス州（Perlis）",
  "サバ州（Sabah）",
  "サラワク州（Sarawak）",
  "セランゴール州（Selangor）",
  "トレンガヌ州（Terengganu）",
  "クアラルンプール（Kuala Lumpur）",
  "プトラジャヤ（Putrajaya）",
  "ラブアン（Labuan）"
]

export const COUNTRIES = [
  { value: "",   label: "Select Country" },
  { value: "MY", label: "Malaysia" },
  { value: "JP", label: "Japan" },
  { value: "SG", label: "Singapore" },
  { value: "TH", label: "Thailand" },
  { value: "Other", label: "Other" }
]